import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteSpinGameMessage,
	fetchSpinGameMessage,
	resetDeleteStatusSpinGameMessage,
	updateSpinGameMessage,
} from "../../../actions/spinTheWheelGameMessage";

import "../Question.scss";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import SpinGameMessageForm from "../../Forms/SpinTheWheelGameMessage";
import { DateTimeFormat } from "../../../helpers/utils";

const SpinGameMessagePage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [spinGameMessageId, setSpinGameMessageId] = useState(null);
	const { status, spinGameMessage } = useSelector(
		(state) => state.fetchSpinGameMessage,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSpinGameMessage,
	);
	const { spinGameMessageDeleted } = useSelector(
		(state) => state.deleteSpinGameMessage,
	);
	console.log("spinGameMessageDeleted ", spinGameMessageDeleted);
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameMessageId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameMessageId(null);
	};

	const handleEdit = () => {
		showModal();
		setSpinGameMessageId(spinGameMessage.id);
		form.setFieldsValue({
			...spinGameMessage,
		});
	};

	const handleDelete = () => {
		dispatch(deleteSpinGameMessage(spinGameMessageId));
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		if (spinGameMessageId) {
			dispatch(updateSpinGameMessage(spinGameMessageId, newValues));
		}
		handleOk();
	};

	useEffect(() => {
		console.log("id ", id);
		if (id) {
			dispatch(fetchSpinGameMessage(id));
		}
	}, [id]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchSpinGameMessage(id));
	}, [updateStatus]);

	useEffect(() => {
		if (spinGameMessageDeleted) {
			history.push("/spin-the-wheel/game-messages");
			dispatch(resetDeleteStatusSpinGameMessage());
		}
	}, [spinGameMessageDeleted]);

	useEffect(() => {
		if (spinGameMessage && spinGameMessage.id === Number(id)) {
			setSpinGameMessageId(spinGameMessage.id);
		} else {
			setSpinGameMessageId();
		}
	}, [spinGameMessage]);
	console.log("spinGameMessage ", spinGameMessage);
	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Game Message Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/spin-the-wheel/game-messages">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Game</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinGameMessage.game.name}
										</div>
									</div>
									<div className="details-item">
										<label>Content</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinGameMessage.content}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{DateTimeFormat(spinGameMessage.updated_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="spin-form-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SpinGameMessageForm
					form={form}
					spinGameMessageId={spinGameMessageId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SpinGameMessagePage;
